import { render } from "./topPartners.vue?vue&type=template&id=5ddddcbb"
import script from "./topPartners.vue?vue&type=script&lang=js"
export * from "./topPartners.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__